import { __assign } from '../../../../_virtual/_tslib.js';
import React from 'react';
import SectionCTA from '../SectionCTA/SectionCTA.js';

var SectionCTAsGroup = function (_a) {
    var value = _a.value, sections = _a.sections, ctaProps = _a.ctaProps, onClick = _a.onClick, showActions = _a.showActions, onEdit = _a.onEdit, className = _a.className;
    return (React.createElement("div", { className: className }, sections === null || sections === void 0 ? void 0 : sections.map(function (section, index) {
        var label = section.label, icon = section.icon, id = section.id, hide = section.hide;
        if (hide)
            return null;
        return (React.createElement(SectionCTA, __assign({ key: id, label: label, icon: icon, active: value === id, onClick: function (e) { return onClick === null || onClick === void 0 ? void 0 : onClick({ index: index, section: section, event: e }); }, showActions: showActions, onEdit: function (e) { return onEdit === null || onEdit === void 0 ? void 0 : onEdit({ index: index, section: section, event: e }); } }, ctaProps)));
    })));
};

export { SectionCTAsGroup as default };
//# sourceMappingURL=SectionCTAsGroup.js.map
